module.exports = __webpack_public_path__ + "static/img/cover.6b49707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/cover.jpg
// module id = muTN
// module chunks = 0